import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { FAQS } from "../mock";

const FAQ = () => {
  return (
    <section id="faq" className="relative py-24 md:py-32 bg-[#f6f1e7]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.2em] text-emerald-900/70 font-semibold mb-4">FAQ</div>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-emerald-950 leading-tight">
            Everything you wanted to ask, <span className="italic text-emerald-700">answered.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl bg-white border border-black/5 px-6 shadow-sm data-[state=open]:shadow-md transition"
            >
              <AccordionTrigger className="text-left font-display text-lg md:text-xl font-semibold text-emerald-950 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-emerald-950/70 text-[15px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
